import { render, staticRenderFns } from "./MilestoneConvertModal.vue?vue&type=template&id=898aefe2&"
import script from "./MilestoneConvertModal.vue?vue&type=script&lang=js&"
export * from "./MilestoneConvertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports